import { IApiError } from '@frontend/request';

import { ILoginResponse } from '@aqx-core/common/api/auth';
import { IAPIControllerCallbacks } from '@aqx-core/common/api/types';

import { omsLoginAPI } from '..';
import { IOMSLoginMobileParams, IOMSLoginParams } from '../model/types';

class OMSLoginAPIController {
  public loginWebOMSDemo = async (params: IOMSLoginParams, callbacks: IAPIControllerCallbacks<ILoginResponse>) => {
    try {
      const { result } = await omsLoginAPI.demoLogin(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileOMSDemo = async (
    params: IOMSLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await omsLoginAPI.demoLoginMobile(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginWebOMSLive = async (params: IOMSLoginParams, callbacks: IAPIControllerCallbacks<ILoginResponse>) => {
    try {
      const { result } = await omsLoginAPI.liveLogin(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };

  public loginMobileOMSLive = async (
    params: IOMSLoginMobileParams,
    callbacks: IAPIControllerCallbacks<ILoginResponse>
  ) => {
    try {
      const { result } = await omsLoginAPI.liveLoginMobile(params);
      callbacks.onSuccess(result);
    } catch (error) {
      callbacks.onError(error as IApiError);
    }
  };
}

export const omsLoginAPIController = new OMSLoginAPIController();
